<template>
    <div>
          <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.zbfilename"  placeholder="招标文件名称" clearable></el-input>
            </el-form-item>
             <el-form-item slot="time">
                 <el-input v-model="pgData.zbfilecode"  placeholder="招标文件编号" clearable></el-input>
            </el-form-item>
            <template slot="btn">
                <el-button icon="el-icon-warning" type="warning" @click="BackHandler()">批量退回</el-button>
            </template>
        </my-search>
        <el-table :data="tableData" border :height="tableHeight" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column label="招标文件编号" prop="zbfilecode"  min-width="200"></el-table-column>
            <el-table-column label="招标文件名称" prop="zbfilename" min-width="200"></el-table-column>
            <el-table-column label="招标项目编号" prop="zbprocode" width="180"></el-table-column>
            <el-table-column label="招标项目名称" prop="zbproname" width="140"></el-table-column>
            <el-table-column label="添加时间" prop="addtime" width="160"></el-table-column>
            <el-table-column label="添加人" prop="addusername" width="140"></el-table-column>
            <el-table-column label="文件类型"  width="140">
                <template slot-scope="scope">
                   <span v-if="scope.row.wjlx==='wj'">
                        招标文件
                   </span>
                   <span v-if="scope.row.wjlx==='cq'">
                        澄清文件
                   </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    icon="el-icon-warning"
                    @click="editHandler({zbfilecode:scope.row.zbfilecode})">
                        退回
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/Zbdl/tuihui/get_zbwjList.json`">
        </my-pagination>

        <my-dialog 
        title="退回" 
        v-model="dialogVisible" 
        width="500px"
        >
            <form-page 
                v-if="dialogVisible"
                :data="form"
                @cancle="dialogClose"
            ></form-page>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormPage from './form'

export default {
    mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { FormPage },
    data() {
        return {
            pgData: {
                sortname: 'addtime',
                sortorder: 'desc',
                pagesize: 20,
                zbfilecode:'',
                zbfilename:''

            },
            zbfilecodes:[],
            form: {}
        }
    },
    methods: {
        unique(arr) {
            return arr.filter(function(item, index, arr) {
                //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
                return arr.indexOf(item, 0) === index;
            });
        },
        handleSelectionChange(val) {
            this.zbfilecodes=[]
            this.multipleSelection = val;
            for(var i=0;i<this.multipleSelection.length;i++) {
                this.zbfilecodes.push(this.multipleSelection[i].zbfilecode)
            }
        },
        BackHandler() {
            ShowConfirm('确认退回？','danger',()=> { 
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/batchthzbwj.json`, {
                    zbfilecodes:this.unique(this.zbfilecodes).join(',')
                }, (data, res) => {
                    ShowMsgBox(res.msg);
                    this.reloadHandler();
                });
            }) 
        }
    },
    created() {
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
